// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","mobile-threshold-width":"760px","mainContainer":"StatusLegendItem_mainContainer__+eRdV","badgeContainer":"StatusLegendItem_badgeContainer__tczt6"};